import FormattedMessage from 'I18n/components/FormattedMessage';
import UIAlert from 'UIComponents/alert/UIAlert';
import GenerateDescriptionErrors from 'automation-ui-management/constants/GenerateDescriptionErrors';
import { FLOW_TYPES } from 'automation-ui-management/constants/CrmPropertyEnums';
import { jsx as _jsx } from "react/jsx-runtime";
const GenerateDescriptionErrorMessage = ({
  error,
  flowType
}) => {
  const isActionSet = flowType === FLOW_TYPES.ACTION_SET;
  if (error === GenerateDescriptionErrors.EMPTY) {
    return /*#__PURE__*/_jsx(UIAlert, {
      titleText: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation-ui-management.WorkflowNameWithDescription.modal.generateDescriptionErrors.empty.title"
      }),
      type: "danger",
      children: isActionSet ? /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation-ui-management.WorkflowNameWithDescription.modal.generateDescriptionErrors.empty.body.actionSet"
      }) : /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation-ui-management.WorkflowNameWithDescription.modal.generateDescriptionErrors.empty.body.workflow"
      })
    });
  } else if (error === GenerateDescriptionErrors.LARGE) {
    return /*#__PURE__*/_jsx(UIAlert, {
      titleText: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation-ui-management.WorkflowNameWithDescription.modal.generateDescriptionErrors.large.title"
      }),
      type: "danger",
      children: isActionSet ? /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation-ui-management.WorkflowNameWithDescription.modal.generateDescriptionErrors.large.body.actionSet"
      }) : /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation-ui-management.WorkflowNameWithDescription.modal.generateDescriptionErrors.large.body.workflow"
      })
    });
  }
  return /*#__PURE__*/_jsx(UIAlert, {
    titleText: isActionSet ? /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation-ui-management.WorkflowNameWithDescription.modal.generateDescriptionErrors.generic.title.actionSet"
    }) : /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation-ui-management.WorkflowNameWithDescription.modal.generateDescriptionErrors.generic.title.workflow"
    }),
    type: "danger",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation-ui-management.WorkflowNameWithDescription.modal.generateDescriptionErrors.generic.body"
    })
  });
};
export default GenerateDescriptionErrorMessage;